<template>
  <router-view />
</template>

<style lang="scss">
@import "assets/css/global.scss";
</style>

<script>
export default {
  name: "App",

  components: {},

  data: () => ({
    //
  }),
};
</script>
